module.exports = __webpack_public_path__ + "img/80.730aba7d.jpg";